import React from 'react';
import { ActivityIcon, HeartHandshakeIcon, StoreIcon } from 'lucide-react';
type ActivityMetric = {
  value: string;
  label: string;
  valueClassName: string;
  icon: React.ElementType;
};
const activityMetrics: ActivityMetric[] = [{
  value: '142',
  label: 'neighbors active online right now nearby',
  valueClassName: 'text-[#008F82]',
  icon: ActivityIcon
}, {
  value: '18',
  label: 'verified pharmacies open near you',
  valueClassName: 'text-[#1C1C1C]',
  icon: StoreIcon
}, {
  value: '1,240+',
  label: 'local patients helped this month',
  valueClassName: 'text-[#E28743]',
  icon: HeartHandshakeIcon
}];
export function LiveActivityCounter() {
  return <section className="w-full border-y border-[#DDE8E0] bg-[#008F82]/5" aria-label="Live local pharmacy activity" data-id="element-101" data-mp="29k6yjfgxirkr">
      <div className="mx-auto flex w-full flex-col items-center justify-around gap-6 px-8 py-6 text-center sm:flex-row md:px-12 lg:px-16" data-id="element-102" data-mp="b5vn2z330fwu">
        {activityMetrics.map(metric => {
        const Icon = metric.icon;
        return <div key={metric.label} className="flex max-w-[210px] flex-col items-center" data-id="element-103" data-mp="11sblzztbxqnb">
              <div className={`mb-3 grid h-10 w-10 place-items-center rounded-full bg-white shadow-sm ${metric.valueClassName}`} data-id="element-104" data-mp="wu0cjq6y5i5m">
                <Icon className="h-5 w-5" data-id="element-105" data-mp="1phmc8nd202n7" />
              </div>
              <p className={`text-2xl font-extrabold tabular-nums ${metric.valueClassName}`} data-id="element-106" data-mp="1pguuafcdq3fe">
                {metric.value}
              </p>
              <p className="mt-1 text-xs leading-5 text-[#6B6B6B]" data-id="element-107" data-mp="1fif36cdcqu5w">
                {metric.label}
              </p>
            </div>;
      })}
      </div>
    </section>;
}